import { useCallback, useState } from 'react';
import { Modal, Upload } from 'antd';
import { cx, css } from '@emotion/css';
import { UploadFile } from 'antd/lib/upload/interface';
import { useToggle } from 'ahooks';
import ProxyVideo from 'components/ProxyVideo';

const styles = {
  footer: css`
    display: flex;
    height: 48px;
    padding-top: 4px;
  `,
  upload: css`
    .ant-upload-list-picture-card {
      display: inline-block;
      width: 100%;
      height: 100%;
      .ant-upload-list-picture-card-container {
        height: 48px;
        width: 48px;
        margin: 0 8px 0 0;
        .ant-upload-list-item {
          width: 48px;
          height: 48px;
          padding: 0;
          margin: 0 8px 0 0;
        }
      }
      .ant-upload-list-item-name {
        display: none;
      }
      video {
        width: 100%;
      }
    }

    .ant-upload-select-picture-card {
      width: 36px;
      height: 36px;
    }

    .ant-upload-list-item-uploading-text {
      margin: 0;
    }

    .ant-upload-select-picture-card > .ant-upload {
      display: flex;
      justify-content: center;
      align-items: center;
      padding: 0;
    }

    .ant-upload-list-item-thumbnail {
      img {
        object-fit: cover;
      }
    }
    .ant-upload-list-item-actions .ant-upload-list-item-card-actions-btn {
      display: none;
    }
    .ant-upload-span {
      height: 100%;
    }
  `,
  previewImageModal: css`
    .ant-modal-content {
      overflow: hidden;
      border-radius: 6px;
    }

    .ant-modal-body {
      padding: 0;
    }
  `,
  previewImage: css`
    width: 100%;
    vertical-align: bottom;
    object-fit: cover;
  `,
};

interface Props {
  fileList?: UploadFile[];
  className?: string;
}

const EditorPreviewerFooter = ({ fileList, className }: Props) => {
  const [visible, { setLeft: hide, setRight: show }] = useToggle();
  const [currentPreviewImage, setCurrentPreviewImage] = useState<UploadFile>();

  const handlePreview = useCallback(
    (file: UploadFile) => {
      setCurrentPreviewImage(file);
      show();
    },
    [show],
  );

  return fileList && fileList.length > 0 ? (
    <div className={cx(className, styles.footer)}>
      <Upload
        className={styles.upload}
        listType="picture-card"
        name="image"
        fileList={fileList}
        onPreview={handlePreview}
        iconRender={(file) =>
          file.url?.includes('.mp4') ? (
            <ProxyVideo src={file.url}>
              <track kind="captions" />
            </ProxyVideo>
          ) : (
            <img alt="" src={file.url} />
          )
        }
      />
      <Modal
        className={styles.previewImageModal}
        visible={visible}
        footer={null}
        onCancel={() => hide()}
      >
        {currentPreviewImage?.url?.includes('mp4') ? (
          <ProxyVideo controls src={currentPreviewImage.url} className={styles.previewImage}>
            <track kind="captions" />
          </ProxyVideo>
        ) : (
          <img alt="example" className={styles.previewImage} src={currentPreviewImage?.url} />
        )}
      </Modal>
    </div>
  ) : null;
};

export default EditorPreviewerFooter;
